import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { NavHeader, Page } from '../../../../../../components';
import { IconAddDevice } from '../../../../../../assets/status-screen-icons/icon-add-device';
import { ROUTES } from '../../../../../../routes/routes';
import { useBluetoothContext } from '../../context';
import './index.scss';

const DeviceAddBluetoothSetWifiSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { disconnect, releaseLock, returnToStartPage } = useBluetoothContext();
  const { t } = useTranslation('device-add');

  useEffect(() => {
    releaseLock();
    disconnect();
  }, []);

  const goToChannels = () => {
    navigate(ROUTES.Channel());
  };

  return (
    <Page
      className="device-add-success"
      containerClassName="page__container--flex-height"
      header={<NavHeader onClick={goToChannels} />}
    >
      <div>
        <div className="icon-container">
          <IconAddDevice />
        </div>
        <div className="text-container">
          <p className="text-header">{t('wifiChangedSuccess.header')}</p>
        </div>
      </div>
      <div className="success-buttons">
        <button className="button" onClick={returnToStartPage}>
          {t('wifiChangedSuccess.addDevice')}
        </button>
        <button className="button button--secondary" onClick={goToChannels}>
          {t('addDeviceSuccess.ready')}
        </button>
      </div>
    </Page>
  );
};

export default DeviceAddBluetoothSetWifiSuccess;
